// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ttAJb","type":"styles_type__1eDXg","choices":"styles_choices__1lv4R"};